const captionCls = "_b7nc9sfzrf";
const contentCls = "_b7nc14sn17t";
const titleCls = "_b7nt1l1t53x";
const spanCls = "_b7ns1wqr94q";

export { captionCls, contentCls, spanCls, titleCls };
import "./atom.slide-caption.style.linaria.module.css";
//# sourceMappingURL=atom.slide-caption.style.js.map
